import React from 'react';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';
import classNames from 'classnames';
import moment from 'moment';
import { isNumber } from 'utils/utils';


const columnData = (statusCode, flag) => {
  return {
    logIdx: {
      colWidth: '50px',
      th: <th rowSpan={2}>No.</th>,
      td: (props) => {
        return <td>{props.index + 1}</td>;
      },
    },
    areaNo: {
      colWidth: '200px',
      th: <th>설비번호</th>,
      td: (props) => {
        return <td>{props.areaNo}</td>;
      },
    },
    areaNm: {
      colWidth: '300px',
      th: <th>설비명</th>,
      td: (props) => {
        return <td>{props.areaNm}</td>;
      },
    },
    modelNo: {
      colWidth: '300px',
      th: <th rowSpan={2}>감지기No.</th>,
      td: (props) => {
        return <td>{props.modelNm}</td>;
      },
    },
    temp: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          온도
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames('data-text', props.temp_status)}>{props.temp.toFixed(1)}<sub>℃</sub></td> : <td colSpan={4}>REPEATER</td>)
      },
    },
    humi: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          습도
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.humi_status)}>{props.humi}<sub>%</sub></td> : <td>-</td> : <></>)
      },
    },
    heatindex: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          체감온도
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.heatindex_status)}>{props.heatindex}<sub>℃</sub></td> : <td>-</td> : <></>)
      },
    },
    status: {
      colWidth: '130px',
      th: <th rowSpan={2}>상태</th>,
      td: (props) => {
        return (statusCode === '0' ? <td>{statusConverterForWhiteBackground(props.status)}</td> : <></>)
      },
    },
    battery: {
      colWidth: '130px',
      th: <th rowSpan={2}>Battery잔량</th>,
      td: (props) => {
        return <td>{Math.floor(props.battery)} %</td>;
      },
    },
    rgstDt: {
      colWidth: '400px',
      th: <th rowSpan={2}>측정시간</th>,
      td: (props) => {
        return <td>{props.rgstDt && moment(props.rgstDt).format('YYYY-MM-DD HH:mm:ss')}</td>;
      },
    },
  };
}

export default columnData;
